@if (visible$ | async) {
  <div class="container">
    <div class="header">
      <span class="header-icon ph-duotone ph-chats-circle"></span>
      @let thread = threadHydratedId()!;
      <div class="header-center">
        <div class="title-row">
          @if (thread.item.title) {
            <span class="header-title">{{ thread.item.title }}</span>
          }
          <a
            class="nav-button size-s"
            icon="ph ph-arrow-square-out"
            alg-button-icon
            [routerLink]="thread.item.route | with: threadParticipantRouteParam() | url: ['task', 'editor']"
            (click)="onNavigateToContent()"
            i18n-title title="Navigate to this content"
          ></a>
        </div>
        @if (participantName$ | async; as name) {
          <div class="user-pill">
            <a class="alg-link user-pill-name" [routerLink]="{ id: participantId()!, isUser: true } | groupLink">
              {{ name }}
            </a>
          </div>
        } @else if (isOwnThreadWhileObserving$ | async) {
          <div class="user-pill own-thread" i18n>Your own thread</div>
        }
      </div>
      <div class="header-right">
        <button
          class="close-button size-s"
          type="button"
          icon="ph ph-x"
          alg-button-icon
          (click)="onClose()"
        ></button>
      </div>
    </div>
    <alg-thread class="thread"></alg-thread>
  </div>
}
